import { apiCall } from "./api";

export const courseService = {
  // Fetch courses for user
  async fetchCourses(userId = null) {
    let endpoint = "/courses";
    if (userId) {
      endpoint += `?user_id=${userId}`;
    }
    return apiCall(endpoint);
  },

  // Fetch courses by group
  async fetchCoursesByGroup(groupId, userId) {
    return apiCall(`/courses/group/${groupId}?user_id=${userId}`);
  },

  // Get specific course
  async getCourse(courseId) {
    return apiCall(`/courses/${courseId}`);
  },

  // Track video access
  async trackVideoAccess(userId, courseId, videoId) {
    return apiCall("/track-video-access", {
      method: "POST",
      body: JSON.stringify({
        user_id: userId,
        course_id: courseId,
        video_id: videoId,
      }),
    });
  },

  // Save course progress
  async saveProgress(courseId, userId, completedVideos) {
    return apiCall(`/courses/${courseId}/progress`, {
      method: "POST",
      body: JSON.stringify({
        user_id: userId,
        completed_videos: completedVideos,
      }),
    });
  },

  // Get course progress
  async getProgress(courseId, userId) {
    return apiCall(`/courses/${courseId}/progress?user_id=${userId}`);
  },
};
